import { onChangeUserOrDate } from '~appointments/lib/onchange';
import { validateRepeatDates, validateRepeatFrequency } from '~appointments/lib/validate';

import { FieldProps } from '~components/form-fields';
import { FormInputRepeatDates, FormInputRepeatFrequency } from '~appointments/components';

import common from './common';

const repeatSpecific: FieldProps = {
  repeat_dates: {
    type: 'custom',
    component: FormInputRepeatDates,
    dependencies: ['repeat', 'repeat_start', 'repeat_end'],
    validateOnSave: validateRepeatDates,
    onChange: onChangeUserOrDate,
    caption: 'Repeat Dates',
    labelCaption: 'Best to select Monday as the start date, in case of future day changes',
    colSize: 4,
    order: 120,
  },
  repeat_frequency: {
    type: 'custom',
    component: FormInputRepeatFrequency,
    dependencies: ['repeat', 'repeat_weekday', 'repeat_week_count', 'skip_on_public_holidays'],
    validate: validateRepeatFrequency,
    caption: 'Frequency',
    labelCaption: "You can only select 1 week day to repeat. Once added, you can select 'Create similar repeat'",
    colSize: 4,
    order: 130,
  },
};

const repeatAppointmentNewFields: FieldProps = {
  ...common,
  ...repeatSpecific,
};

export default { repeatSpecific, repeatAppointmentNewFields };
